/* eslint-disable no-use-before-define */

/* eslint-disable no-unused-vars */

/* eslint-disable @typescript-eslint/no-unused-vars */
import React from "react";
import {
  Platform,
  Animated,
  StyleProp,
  ViewStyle,
  StyleSheet,
  View,
  TextStyle,
  Easing,
} from "react-native";
import { interpolate } from "flubber";
import SVG_Svg, {
  G as SVG_G,
  Path as SVG_Path,
  GProps,
  PathProps,
} from "react-native-svg";
/* SVGR has dropped some elements not supported by react-native-svg: desc */

/***/

const Path = Animated.createAnimatedComponent<
  React.ComponentClass<
    PathProps & {
      style?: StyleProp<ViewStyle>;
    }
  >
>(SVG_Path);
const G = Animated.createAnimatedComponent<
  React.ComponentClass<
    GProps & {
      style?: StyleProp<ViewStyle>;
    }
  >
>(SVG_G);
const Svg = Animated.createAnimatedComponent(SVG_Svg);

/*
 * -------------------------------------------------------------------------
 *
 *  /$$$$$$                                /$$$$$$$  /$$
 * |_  $$_/                               | $$__  $$| $$
 *   | $$   /$$$$$$/$$$$   /$$$$$$        | $$  \ $$| $$ /$$   /$$  /$$$$$$
 *   | $$  | $$_  $$_  $$ /$$__  $$       | $$$$$$$ | $$| $$  | $$ /$$__  $$
 *   | $$  | $$ \ $$ \ $$| $$  \ $$       | $$__  $$| $$| $$  | $$| $$$$$$$$
 *   | $$  | $$ | $$ | $$| $$  | $$       | $$  \ $$| $$| $$  | $$| $$_____/
 *  /$$$$$$| $$ | $$ | $$| $$$$$$$/  /$$  | $$$$$$$/| $$|  $$$$$$/|  $$$$$$$
 * |______/|__/ |__/ |__/| $$____/  |__/  |_______/ |__/ \______/  \_______/
 *                       | $$
 *                       | $$
 *                       |__/
 *
 * -------------------------------------------------------------------------
 *
 * ORIGINAL SVG - STATE 0
 * ---------------------------------
 * <svg xmlns="http://www.w3.org/2000/svg" width="87" height="61" viewBox="0 0 87 61" fill="none"> <desc id="IMP.BLUE">{"#MagicBox":{"type":"SELECTOR","constraint":"none","width":202,"height":77.76106262207031},"#Property_201_3DClosed":{"type":"SELECTOR","constraint":"xMinYMin meet","width":85.80531311035156,"height":59.88495635986328},"#Rectangle_20391":{"type":"SELECTOR","constraint":"xMinYMin meet","width":35.3053092956543,"height":27.707963943481445},"#Vector_202":{"type":"SELECTOR","constraint":"xMinYMin meet","width":13.407079696655273,"height":7.597345352172852},"#Vector_203":{"type":"SELECTOR","constraint":"xMinYMin meet","width":13.407079696655273,"height":7.597345352172852},"#Subtract":{"type":"SELECTOR","constraint":"xMinYMin meet","width":9.83185863494873,"height":17.75012969970703},"#Top":{"type":"SELECTOR","constraint":"xMinYMin meet","width":39.05039978027344,"height":22.790143966674805},"#Star_201":{"type":"SELECTOR","constraint":"xMinYMin meet","width":4.915929317474365,"height":6.256637096405029},"#Star_202":{"type":"SELECTOR","constraint":"xMinYMin meet","width":4.915929317474365,"height":4.915929317474365},"#Star_203":{"type":"SELECTOR","constraint":"xMinYMin meet","width":7.597345352172852,"height":7.597345352172852},"#Star_204":{"type":"SELECTOR","constraint":"xMinYMin meet","width":8.938053131103516,"height":7.597345352172852},"#Property_201_3DOpen":{"type":"SELECTOR","constraint":"xMinYMin meet","width":85.80531311035156,"height":59.88495635986328},"transforms":{},"morph":{"condition":"props.morph","targets":{"Property_1=Closed":{"type":"ease","duration":500,"delay":2000},"Property_1=Open":{"type":"elasticOut","duration":500,"delay":0}},"numStates":2}}</desc>
 * <g id="Property 1=Closed">
 * <rect id="Rectangle 391" x="6.07819" y="32.4447" width="33.0708" height="25.4734" rx="1.11726" fill="#F1F1F1" stroke="black" stroke-width="2.23451"/>
 * <path id="Vector 2" d="M22.3906 25.0673C27.044 21.0489 32.1407 14.3006 35.0213 19.1736C38.7112 25.4156 28.3736 25.0673 22.3906 25.0673Z" fill="#F1F1F1" stroke="black" stroke-width="2.23451" stroke-linejoin="round"/>
 * <path id="Vector 3" d="M22.8359 25.0673C18.1825 21.0489 13.0859 14.3006 10.2052 19.1736C6.51534 25.4156 16.853 25.0673 22.8359 25.0673Z" fill="#F1F1F1" stroke="black" stroke-width="2.23451" stroke-linejoin="round"/>
 * <path id="Subtract" d="M18.5899 46.2934V32.4447H26.1873V46.3448L23.7681 43.8809C22.9734 43.0715 21.6659 43.078 20.8803 43.8992L18.5899 46.2934ZM26.5702 46.7348L26.5699 46.7345L26.5702 46.7348Z" stroke="black" stroke-width="2.23451" stroke-linejoin="round"/>
 * <path id="Top" d="M3.3946 26.8584C3.3946 26.2414 3.89481 25.7412 4.51186 25.7412H40.2641C40.8811 25.7412 41.3813 26.2414 41.3813 26.8584V31.3274C41.3813 31.9445 40.8811 32.4447 40.2641 32.4447H4.51186C3.89481 32.4447 3.3946 31.9445 3.3946 31.3274V26.8584Z" fill="#F1F1F1" stroke="black" stroke-width="2.23451"/>
 * <path id="Star 1" d="M33.0337 32.0241C33.0592 31.9455 33.1705 31.9455 33.196 32.0241C33.2075 32.0593 33.2402 32.0831 33.2772 32.0831C33.3599 32.0831 33.3943 32.1889 33.3274 32.2375C33.2975 32.2593 33.285 32.2978 33.2964 32.333C33.3219 32.4116 33.2319 32.477 33.165 32.4284C33.1351 32.4066 33.0946 32.4066 33.0647 32.4284C32.9978 32.477 32.9078 32.4116 32.9334 32.333C32.9448 32.2978 32.9323 32.2593 32.9024 32.2375C32.8355 32.1889 32.8698 32.0831 32.9525 32.0831C32.9895 32.0831 33.0223 32.0593 33.0337 32.0241Z" fill="black"/>
 * <path id="Star 2" d="M33.0337 32.0241C33.0592 31.9455 33.1705 31.9455 33.196 32.0241C33.2075 32.0593 33.2402 32.0831 33.2772 32.0831C33.3599 32.0831 33.3943 32.1889 33.3274 32.2375C33.2975 32.2593 33.285 32.2978 33.2964 32.333C33.3219 32.4116 33.2319 32.477 33.165 32.4284C33.1351 32.4066 33.0946 32.4066 33.0647 32.4284C32.9978 32.477 32.9078 32.4116 32.9334 32.333C32.9448 32.2978 32.9323 32.2593 32.9024 32.2375C32.8355 32.1889 32.8698 32.0831 32.9525 32.0831C32.9895 32.0831 33.0223 32.0593 33.0337 32.0241Z" fill="black"/>
 * <path id="Star 3" d="M33.2166 32.1491C33.2549 32.0311 33.4218 32.0311 33.4601 32.1491C33.4772 32.2018 33.5264 32.2375 33.5818 32.2375C33.7059 32.2375 33.7574 32.3962 33.6571 32.4691C33.6122 32.5017 33.5934 32.5595 33.6106 32.6123C33.6489 32.7302 33.5139 32.8283 33.4136 32.7554C33.3687 32.7228 33.3079 32.7228 33.2631 32.7554C33.1627 32.8283 33.0277 32.7302 33.0661 32.6123C33.0832 32.5595 33.0644 32.5017 33.0196 32.4691C32.9192 32.3962 32.9708 32.2375 33.0948 32.2375C33.1503 32.2375 33.1994 32.2018 33.2166 32.1491Z" fill="black"/>
 * <path id="Star 4" d="M33.2166 32.1491C33.2549 32.0311 33.4218 32.0311 33.4601 32.1491C33.4772 32.2018 33.5264 32.2375 33.5818 32.2375C33.7059 32.2375 33.7574 32.3962 33.6571 32.4691C33.6122 32.5017 33.5934 32.5595 33.6106 32.6123C33.6489 32.7302 33.5139 32.8283 33.4136 32.7554C33.3687 32.7228 33.3079 32.7228 33.2631 32.7554C33.1627 32.8283 33.0277 32.7302 33.0661 32.6123C33.0832 32.5595 33.0644 32.5017 33.0196 32.4691C32.9192 32.3962 32.9708 32.2375 33.0948 32.2375C33.1503 32.2375 33.1994 32.2018 33.2166 32.1491Z" fill="black"/>
 * </g>
 * </svg>
 *
 * ---------------------------------
 *
 * MORPH TARGET - STATE 1
 * ---------------------------------
 * <svg xmlns="http://www.w3.org/2000/svg" width="88" height="61" viewBox="0 0 88 61" fill="none">
 * <g id="Property 1=Open">
 * <rect id="Rectangle 391" x="6.3946" y="32.4447" width="33.0708" height="25.4734" rx="1.11726" fill="#F1F1F1" stroke="black" stroke-width="2.23451"/>
 * <path id="Star 1" d="M43.4057 21.4538C43.6837 21.0837 44.2718 21.3284 44.2053 21.7864L44.1861 21.9183C44.1568 22.1204 44.2682 22.3167 44.4568 22.3952L44.7311 22.5093C45.1065 22.6655 45.0953 23.2012 44.7136 23.3414L44.1879 23.5345C44.034 23.5911 43.9234 23.7275 43.8998 23.8898L43.8348 24.3372C43.7708 24.7779 43.1721 24.8641 42.9864 24.4594L42.9689 24.4213C42.8716 24.2093 42.6276 24.1078 42.4086 24.1882L42.3693 24.2027C41.9513 24.3562 41.5904 23.8709 41.8578 23.5148L42.1293 23.1533C42.2278 23.0222 42.2466 22.8476 42.1782 22.6985L41.9446 22.1896C41.7749 21.82 42.1469 21.4343 42.5224 21.5905L42.7967 21.7046C42.9853 21.7831 43.203 21.7237 43.3257 21.5604L43.4057 21.4538Z" fill="black"/>
 * <path id="Star 2" d="M52.2608 22.3889C52.5477 22.0646 53.0819 22.2968 53.0404 22.7278L53.0322 22.8131C53.0137 23.0058 53.1213 23.1885 53.2989 23.2657L53.3775 23.2999C53.7745 23.4725 53.7187 24.0523 53.2961 24.146L53.2124 24.1646C53.0234 24.2065 52.8829 24.3654 52.8643 24.5581L52.8561 24.6434C52.8147 25.0743 52.246 25.2004 52.0262 24.8274L51.9827 24.7536C51.8844 24.5868 51.6899 24.5022 51.5009 24.5442L51.4173 24.5627C50.9946 24.6564 50.6989 24.1546 50.9858 23.8303L51.0425 23.7661C51.1708 23.6211 51.1911 23.41 51.0928 23.2432L51.0493 23.1693C50.8296 22.7963 51.2155 22.36 51.6126 22.5326L51.6912 22.5668C51.8687 22.644 52.0758 22.5981 52.2041 22.4531L52.2608 22.3889Z" fill="black"/>
 * <path id="Star 3" d="M51.549 27.4414C51.8483 27.1286 52.373 27.3816 52.3147 27.8106L52.172 28.8607C52.146 29.0525 52.2464 29.2394 52.4208 29.3234L53.3754 29.7836C53.7654 29.9716 53.687 30.5488 53.261 30.626L52.2182 30.8148C52.0277 30.8493 51.881 31.0025 51.8549 31.1943L51.7123 32.2445C51.654 32.6735 51.0808 32.7772 50.8758 32.3959L50.374 31.4625C50.2823 31.2919 50.0913 31.1998 49.9007 31.2343L48.8579 31.4231C48.4319 31.5002 48.1561 30.9872 48.4554 30.6744L49.1881 29.9087C49.322 29.7688 49.3505 29.5586 49.2588 29.3881L48.757 28.4547C48.552 28.0734 48.9547 27.6525 49.3447 27.8405L50.2994 28.3007C50.4738 28.3848 50.6825 28.347 50.8163 28.2071L51.549 27.4414Z" fill="black"/>
 * <path id="Star 4" d="M49.5654 15.1471C49.9398 14.9798 50.3231 15.363 50.1557 15.7375L49.6117 16.9548C49.5361 17.1239 49.5727 17.3221 49.7037 17.4531L50.669 18.4184C50.9874 18.7368 50.6883 19.273 50.2502 19.1694L49.1375 18.9063C48.9287 18.8569 48.7142 18.963 48.6267 19.1589L48.17 20.1807C47.9956 20.5709 47.4255 20.5172 47.3271 20.1012L46.9842 18.6508C46.9453 18.4861 46.8167 18.3576 46.6521 18.3187L45.2017 17.9758C44.7857 17.8774 44.7319 17.3072 45.1222 17.1328L46.144 16.6762C46.3399 16.5886 46.4459 16.3742 46.3966 16.1653L46.1335 15.0527C46.0299 14.6145 46.566 14.3155 46.8844 14.6339L47.8497 15.5992C47.9807 15.7301 48.1789 15.7667 48.3481 15.6912L49.5654 15.1471Z" fill="black"/>
 * <path id="Vector 2" d="M18.5437 20.8351C21.215 15.2974 23.2072 7.07879 27.7884 10.4041C33.6564 14.6635 24.0331 18.4555 18.5437 20.8351Z" fill="#F1F1F1" stroke="black" stroke-width="2.23451" stroke-linejoin="round"/>
 * <path id="Vector 3" d="M18.9539 20.6572C13.0861 18.8211 5.72597 14.6566 5.02107 20.2734C4.11817 27.4679 13.4645 23.0368 18.9539 20.6572Z" fill="#F1F1F1" stroke="black" stroke-width="2.23451" stroke-linejoin="round"/>
 * <path id="Subtract" d="M18.9102 46.2934V32.4447H26.5076V46.3448L24.0884 43.8809C23.2937 43.0715 21.9862 43.078 21.2006 43.8992L18.9102 46.2934ZM26.8905 46.7348L26.8902 46.7345L26.8905 46.7348Z" stroke="black" stroke-width="2.23451" stroke-linejoin="round"/>
 * <path id="Top" d="M1.83109 30.0326C1.58567 29.4664 1.84567 28.8085 2.41181 28.5631L35.2146 14.3435C35.7807 14.0981 36.4386 14.3581 36.684 14.9242L38.4615 19.0245C38.7069 19.5907 38.4469 20.2486 37.8808 20.494L5.07799 34.7136C4.51185 34.959 3.85396 34.6991 3.60854 34.1329L1.83109 30.0326Z" fill="#F1F1F1" stroke="black" stroke-width="2.23451"/>
 * </g>
 * </svg>
 *
 * ---------------------------------
 *
 * CONFIGURATION
 * ---------------------------------
 * {
 * 	"#MagicBox": {
 * 		"type": "SELECTOR",
 * 		"constraint": "none",
 * 		"width": 202,
 * 		"height": 77.76106262207031
 * 	},
 * 	"#Property_201_3DClosed": {
 * 		"type": "SELECTOR",
 * 		"constraint": "xMinYMin meet",
 * 		"width": 85.80531311035156,
 * 		"height": 59.88495635986328
 * 	},
 * 	"#Rectangle_20391": {
 * 		"type": "SELECTOR",
 * 		"constraint": "xMinYMin meet",
 * 		"width": 35.3053092956543,
 * 		"height": 27.707963943481445
 * 	},
 * 	"#Vector_202": {
 * 		"type": "SELECTOR",
 * 		"constraint": "xMinYMin meet",
 * 		"width": 13.407079696655273,
 * 		"height": 7.597345352172852
 * 	},
 * 	"#Vector_203": {
 * 		"type": "SELECTOR",
 * 		"constraint": "xMinYMin meet",
 * 		"width": 13.407079696655273,
 * 		"height": 7.597345352172852
 * 	},
 * 	"#Subtract": {
 * 		"type": "SELECTOR",
 * 		"constraint": "xMinYMin meet",
 * 		"width": 9.83185863494873,
 * 		"height": 17.75012969970703
 * 	},
 * 	"#Top": {
 * 		"type": "SELECTOR",
 * 		"constraint": "xMinYMin meet",
 * 		"width": 39.05039978027344,
 * 		"height": 22.790143966674805
 * 	},
 * 	"#Star_201": {
 * 		"type": "SELECTOR",
 * 		"constraint": "xMinYMin meet",
 * 		"width": 4.915929317474365,
 * 		"height": 6.256637096405029
 * 	},
 * 	"#Star_202": {
 * 		"type": "SELECTOR",
 * 		"constraint": "xMinYMin meet",
 * 		"width": 4.915929317474365,
 * 		"height": 4.915929317474365
 * 	},
 * 	"#Star_203": {
 * 		"type": "SELECTOR",
 * 		"constraint": "xMinYMin meet",
 * 		"width": 7.597345352172852,
 * 		"height": 7.597345352172852
 * 	},
 * 	"#Star_204": {
 * 		"type": "SELECTOR",
 * 		"constraint": "xMinYMin meet",
 * 		"width": 8.938053131103516,
 * 		"height": 7.597345352172852
 * 	},
 * 	"#Property_201_3DOpen": {
 * 		"type": "SELECTOR",
 * 		"constraint": "xMinYMin meet",
 * 		"width": 85.80531311035156,
 * 		"height": 59.88495635986328
 * 	},
 * 	"transforms": {},
 * 	"morph": {
 * 		"condition": "props.morph",
 * 		"targets": {
 * 			"Property_1=Closed": {
 * 				"type": "ease",
 * 				"duration": 500,
 * 				"delay": 2000
 * 			},
 * 			"Property_1=Open": {
 * 				"type": "elasticOut",
 * 				"duration": 500,
 * 				"delay": 0
 * 			}
 * 		},
 * 		"numStates": 2
 * 	}
 * }
 * ---------------------------------
 *
 * DESCRIPTION
 * ---------------------------------
 * No description provided!
 * ---------------------------------
 */

/** Component Properties Interface */
export type tProps = {
  style?: tStyle;
  svgStyle?: tStyle;
  isInsideScrollView?: boolean;
  svgRef?: () => void;
  hasDelay?: boolean;
  morph?: number;
  maxSegmentLength?: number;
  Property_1?: "Closed" | "Open";
  onAnimationComplete?: () => void;
};
/***/

/***/

export type tStyle = StyleProp<ViewStyle>;
export type tTextStyle = StyleProp<TextStyle>;
/** Morphing Types */

type tReactRefUnknown = React.Ref<React.Component<unknown, unknown, unknown>>;
type tMorphRef = Animated.WithAnimatedValue<tReactRefUnknown> & tReactRefUnknown;
type tPathRef = typeof Path & {
  // Native Control
  setNativeProps: ({ d, matrix }: { d?: string; matrix?: number[] }) => void; // Web Control

  _touchableNode: {
    setAttribute: (attr: string, val: string) => void;
  }; // Get Ids

  props: {
    id: string;
  };
};
type tMorphProps = {
  morphConfigRectangle_20391d: string | number | Animated.AnimatedInterpolation;
  morphConfigVector_202d: string | number | Animated.AnimatedInterpolation;
  morphConfigVector_203d: string | number | Animated.AnimatedInterpolation;
  morphConfigSubtractd: string | number | Animated.AnimatedInterpolation;
  morphConfigTopd: string | number | Animated.AnimatedInterpolation;
  morphConfigStar_201d: string | number | Animated.AnimatedInterpolation;
  morphConfigStar_202d: string | number | Animated.AnimatedInterpolation;
  morphConfigStar_203d: string | number | Animated.AnimatedInterpolation;
  morphConfigStar_204d: string | number | Animated.AnimatedInterpolation;
  bindInterpolation: tMorphRef;
};
/***/

/** Convenience for prop insertion from ast (no-color-literals/no-inline-styles) */

/* eslint-disable react-native/no-color-literals */

/* eslint-disable react-native/no-inline-styles */

/** Local Styles */

const kLocalStyles = StyleSheet.create({
  kOverlay: {
    left: 0,
    position: "absolute",
    top: 0,
  },
});
/***/

/***/

/**
 * Auto-Generated Imp.Blue Component based on your design!
 * @param {tProps} props Developer interface to the component!
 * @returns {JSX.Element} JSX
 *
 * Description --
 * No description provided!
 */

export const MagicBox = (props: {
  style?: tStyle;
  svgStyle?: tStyle;
  isInsideScrollView?: boolean;
  svgRef?: () => void;
  hasDelay?: boolean;
  morph?: number;
  maxSegmentLength?: number;
  Property_1?: "Closed" | "Open";
  onAnimationComplete?: () => void;
}): JSX.Element => {
  const {
    style = {
      width: 88,
      height: 61,
    },
    svgStyle = {
      width: "100%",
      height: "100%",
    },
    svgRef,
  } = props;
  /** Component Internal State */

  const [morphState] = React.useState<{
    morphAnimVal: Animated.Value;
    morphProps: tMorphProps;
  }>({
    morphAnimVal: new Animated.Value(0),
    morphProps: {
      bindInterpolation: () => undefined,
      morphConfigRectangle_20391d:
        "M7.19545 32.4447 H38.031729999999996 a1.11726,1.11726 0 0 1 1.11726,1.11726 V56.800839999999994 a1.11726,1.11726 0 0 1 -1.11726,1.11726 H7.19545 a1.11726,1.11726 0 0 1 -1.11726,-1.11726 V33.56196 a1.11726,1.11726 0 0 1 1.11726,-1.11726z",
      morphConfigVector_202d:
        "M22.3906 25.0673C27.044 21.0489 32.1407 14.3006 35.0213 19.1736C38.7112 25.4156 28.3736 25.0673 22.3906 25.0673Z",
      morphConfigVector_203d:
        "M22.8359 25.0673C18.1825 21.0489 13.0859 14.3006 10.2052 19.1736C6.51534 25.4156 16.853 25.0673 22.8359 25.0673Z",
      morphConfigSubtractd:
        "M18.5899 46.2934V32.4447H26.1873V46.3448L23.7681 43.8809C22.9734 43.0715 21.6659 43.078 20.8803 43.8992L18.5899 46.2934ZM26.5702 46.7348L26.5699 46.7345L26.5702 46.7348Z",
      morphConfigTopd:
        "M3.3946 26.8584C3.3946 26.2414 3.89481 25.7412 4.51186 25.7412H40.2641C40.8811 25.7412 41.3813 26.2414 41.3813 26.8584V31.3274C41.3813 31.9445 40.8811 32.4447 40.2641 32.4447H4.51186C3.89481 32.4447 3.3946 31.9445 3.3946 31.3274V26.8584Z",
      morphConfigStar_201d:
        "M33.0337 32.0241C33.0592 31.9455 33.1705 31.9455 33.196 32.0241C33.2075 32.0593 33.2402 32.0831 33.2772 32.0831C33.3599 32.0831 33.3943 32.1889 33.3274 32.2375C33.2975 32.2593 33.285 32.2978 33.2964 32.333C33.3219 32.4116 33.2319 32.477 33.165 32.4284C33.1351 32.4066 33.0946 32.4066 33.0647 32.4284C32.9978 32.477 32.9078 32.4116 32.9334 32.333C32.9448 32.2978 32.9323 32.2593 32.9024 32.2375C32.8355 32.1889 32.8698 32.0831 32.9525 32.0831C32.9895 32.0831 33.0223 32.0593 33.0337 32.0241Z",
      morphConfigStar_202d:
        "M33.0337 32.0241C33.0592 31.9455 33.1705 31.9455 33.196 32.0241C33.2075 32.0593 33.2402 32.0831 33.2772 32.0831C33.3599 32.0831 33.3943 32.1889 33.3274 32.2375C33.2975 32.2593 33.285 32.2978 33.2964 32.333C33.3219 32.4116 33.2319 32.477 33.165 32.4284C33.1351 32.4066 33.0946 32.4066 33.0647 32.4284C32.9978 32.477 32.9078 32.4116 32.9334 32.333C32.9448 32.2978 32.9323 32.2593 32.9024 32.2375C32.8355 32.1889 32.8698 32.0831 32.9525 32.0831C32.9895 32.0831 33.0223 32.0593 33.0337 32.0241Z",
      morphConfigStar_203d:
        "M33.2166 32.1491C33.2549 32.0311 33.4218 32.0311 33.4601 32.1491C33.4772 32.2018 33.5264 32.2375 33.5818 32.2375C33.7059 32.2375 33.7574 32.3962 33.6571 32.4691C33.6122 32.5017 33.5934 32.5595 33.6106 32.6123C33.6489 32.7302 33.5139 32.8283 33.4136 32.7554C33.3687 32.7228 33.3079 32.7228 33.2631 32.7554C33.1627 32.8283 33.0277 32.7302 33.0661 32.6123C33.0832 32.5595 33.0644 32.5017 33.0196 32.4691C32.9192 32.3962 32.9708 32.2375 33.0948 32.2375C33.1503 32.2375 33.1994 32.2018 33.2166 32.1491Z",
      morphConfigStar_204d:
        "M33.2166 32.1491C33.2549 32.0311 33.4218 32.0311 33.4601 32.1491C33.4772 32.2018 33.5264 32.2375 33.5818 32.2375C33.7059 32.2375 33.7574 32.3962 33.6571 32.4691C33.6122 32.5017 33.5934 32.5595 33.6106 32.6123C33.6489 32.7302 33.5139 32.8283 33.4136 32.7554C33.3687 32.7228 33.3079 32.7228 33.2631 32.7554C33.1627 32.8283 33.0277 32.7302 33.0661 32.6123C33.0832 32.5595 33.0644 32.5017 33.0196 32.4691C32.9192 32.3962 32.9708 32.2375 33.0948 32.2375C33.1503 32.2375 33.1994 32.2018 33.2166 32.1491Z",
    },
  });
  /** Component Internal Functions */

  /** Custom React-Hooks */

  /**
   * Custom hook to emulate onLayout events
   * (For use in web env only!)
   */

  /** End Custom React-Hooks */

  /** Morph Wrapper */

  type tMorphProperty = {
    Property_1: "Closed" | "Open";
  };
  type tMorphProperties = {
    [key: string]: tMorphProperty;
  };
  const morphStates: tMorphProperties = {
    0: {
      Property_1: "Closed",
    },
    1: {
      Property_1: "Open",
    },
  };

  function getNextMorphState(): number {
    const { Property_1, morph = 0 } = props;
    let nextState = morph;
    Object.keys(morphStates).forEach((possibleMorphState) => {
      if (morphStates[possibleMorphState].Property_1 === Property_1) {
        nextState = parseInt(possibleMorphState, 10);
      }
    });
    return nextState;
  }

  const { morphAnimVal, morphProps } = morphState;
  const maxSegmentLength = props?.maxSegmentLength ?? 1;

  const onAnimationComplete: () => void = props?.onAnimationComplete ?? (() => 0);

  const currValueRef = React.useRef(0);
  const nextValue: number = getNextMorphState() ?? 1;
  const currValue = currValueRef.current;
  let startValue = Math.floor(currValue);
  let endValue = Math.ceil(nextValue);

  if (currValue > nextValue) {
    startValue = Math.ceil(currValue);
    endValue = Math.floor(nextValue);
  }
  /**
   * Normalize an input to a range of 0 to 1
   */

  const normalize = (x: number, bound1: number, bound2: number) => {
    let result = 0;
    const aNumerator = x - Math.min(bound1, bound2);
    const aDenominator = Math.max(bound1, bound2) - Math.min(bound1, bound2);

    if (aDenominator !== 0) {
      result = aNumerator / aDenominator;
    }

    if (Number.isNaN(result)) {
      result = 0;
    }

    return result;
  };
  /**
   * Generates an interpolation function from 2 Matrices
   * This function will perform component-wise linear interpolation from matrix A to B at a given time value t
   */

  const interpolateMatrices = (m1: number[], m2: number[]) => {
    // linear interpolation
    const lerp = (x0: number, x1: number, t: number) => x0 * (1 - t) + x1 * t;

    return (t: number) => m1.map((x0, i) => lerp(x0, m2[i], t));
  };

  type tMorphInterpolation = {
    type: "Morph";
    morphId: keyof tMorphProps;
    paths: string[];
  };
  type tMatrixInterpolation = {
    type: "Matrix";
    morphId: keyof tMorphProps;
    matrices: number[][];
  };
  /**
   * Custom Hook to Control Animation Interpolation of SVG Paths
   */

  const useGenerateMorphInterpolation = (
    interpolations: Array<tMorphInterpolation | tMatrixInterpolation>,
    start: number,
    end: number,
  ) => {
    const refs = React.useRef<Record<string, tPathRef>>({});
    React.useEffect(() => {
      if (interpolations.length === 0) return () => 0;
      type tInterpolator = (t: number) => string;
      type tInterpolatorMorph = {
        type: "Normal" | "SubPath";
        interpolator: (t: number) => string;
      };
      type tInterpolatorMatrix = {
        type: "Matrix";
        interpolator: (t: number) => number[];
      };

      const toSubPaths = (myPath: string) =>
        String(myPath)
          .split(/m|M/)
          .filter((subPath) => Boolean(subPath))
          .map((subPath) => `M${subPath}${subPath.endsWith("Z") ? "" : "Z"}`);

      const interpolators: {
        [morphId: string]: tInterpolatorMorph | tInterpolatorMatrix;
      } = {};
      interpolations.forEach((interpolation) => {
        if (interpolation.type === "Morph") {
          const { morphId, paths } = interpolation;
          const initial = paths[start];
          const final = paths[end];
          const p1 = start > end ? final : initial;
          const p2 = start > end ? initial : final;
          const defaultInterpolator = interpolate(p1, p2, {
            maxSegmentLength,
          });
          const p1SubPaths = toSubPaths(p1);
          const p2SubPaths = toSubPaths(p2);
          const newSubPaths: tInterpolator[] = [];
          let type: tInterpolatorMorph["type"] = "Normal";

          if (p1SubPaths.length > 1 && p2SubPaths.length > 1 && p1SubPaths.length === p2SubPaths.length) {
            type = "SubPath";

            for (let i = 0; i < p1SubPaths.length; i += 1) {
              const subP1 = p1SubPaths[i];
              const subP2 = p2SubPaths[i];
              newSubPaths.push(
                interpolate(subP1, subP2, {
                  maxSegmentLength,
                }),
              );
            }
          }

          const interpolator = (t: number) => {
            if (type === "SubPath") {
              return `${newSubPaths.map((subInterpolator) => subInterpolator(t).replace(/z|Z/g, "")).join(" ")}Z`;
            }

            return defaultInterpolator(t);
          };

          interpolators[morphId] = {
            type,
            interpolator,
          };
        } else if (interpolation.type === "Matrix") {
          const { type, morphId, matrices } = interpolation;
          const initial = matrices[start];
          const final = matrices[end];
          const m1 = start > end ? final : initial;
          const m2 = start > end ? initial : final;
          const interpolator = interpolateMatrices(m1, m2);
          interpolators[morphId] = {
            type,
            interpolator,
          };
        }
      });

      const onValueChange = ({ value }: { value: number }) => {
        Object.entries(interpolators).forEach(([morphId, interpolation]) => {
          const normal = normalize(value, start, end);
          let nextInterpolatedPath = "";
          let nextInterpolatedMatrix: number[] = [];

          if (interpolation.type === "Normal" || interpolation.type === "SubPath") {
            const { interpolator } = interpolation;
            nextInterpolatedPath = interpolator(normal);
          }

          if (interpolation.type === "Matrix") {
            const { interpolator } = interpolation;
            nextInterpolatedMatrix = interpolator(normal);
          }

          if (morphId in refs.current) {
            const thisRef = refs.current[morphId];

            if (Platform.OS === "web") {
              if (interpolation.type !== "Matrix") {
                thisRef?._touchableNode?.setAttribute("d", nextInterpolatedPath);
              } else {
                thisRef?._touchableNode?.setAttribute("transform", `matrix(${nextInterpolatedMatrix.join(" ")})`);
              }
            } else if (interpolation.type !== "Matrix") {
              thisRef?.setNativeProps({
                d: nextInterpolatedPath,
              });
            } else {
              thisRef?.setNativeProps({
                matrix: nextInterpolatedMatrix,
              });
            }
          }
        });
      };

      const listenerId = morphAnimVal.addListener(onValueChange);
      return () => morphAnimVal.removeListener(listenerId);
    }, [interpolations, start, end]);
    return (((ref: tPathRef) => {
      const id = ref?.props?.id ?? "unknown";

      if (refs && refs.current) {
        refs.current[`morphConfig${id}d`] = ref;
      }
    }) as unknown) as tMorphRef;
  };

  const myInterpolations: Array<tMorphInterpolation | tMatrixInterpolation> = React.useMemo(
    () => [
      {
        type: "Matrix",
        morphId: "morphConfigRectangle_20391d",
        matrices: [
          [1, 0, 0, 1, 0, 0],
          [1, 0, 0, 1, 0.31641000000036, 0],
        ],
      },
      {
        type: "Morph",
        morphId: "morphConfigVector_202d",
        paths: [
          "M22.3906 25.0673C27.044 21.0489 32.1407 14.3006 35.0213 19.1736C38.7112 25.4156 28.3736 25.0673 22.3906 25.0673Z",
          "M18.5437 20.8351C21.215 15.2974 23.2072 7.07879 27.7884 10.4041C33.6564 14.6635 24.0331 18.4555 18.5437 20.8351Z",
        ],
      },
      {
        type: "Morph",
        morphId: "morphConfigVector_203d",
        paths: [
          "M22.8359 25.0673C18.1825 21.0489 13.0859 14.3006 10.2052 19.1736C6.51534 25.4156 16.853 25.0673 22.8359 25.0673Z",
          "M18.9539 20.6572C13.0861 18.8211 5.72597 14.6566 5.02107 20.2734C4.11817 27.4679 13.4645 23.0368 18.9539 20.6572Z",
        ],
      },
      {
        type: "Matrix",
        morphId: "morphConfigSubtractd",
        matrices: [
          [1, 0, 0, 1, 0, 0],
          [1, 0, -2.2503119222992416e-16, 0.9999999999999998, 0.3202999999999889, -1.4210854715202004e-14],
        ],
      },
      {
        type: "Matrix",
        morphId: "morphConfigTopd",
        matrices: [
          [1, 0, 0, 1, 0, 0],
          [
            0.9175030711362415,
            -0.3977261284887382,
            0.39775284752745954,
            0.9175944375981704,
            -11.966471005310598,
            6.73760267298119,
          ],
        ],
      },
      {
        type: "Morph",
        morphId: "morphConfigStar_201d",
        paths: [
          "M33.0337 32.0241C33.0592 31.9455 33.1705 31.9455 33.196 32.0241C33.2075 32.0593 33.2402 32.0831 33.2772 32.0831C33.3599 32.0831 33.3943 32.1889 33.3274 32.2375C33.2975 32.2593 33.285 32.2978 33.2964 32.333C33.3219 32.4116 33.2319 32.477 33.165 32.4284C33.1351 32.4066 33.0946 32.4066 33.0647 32.4284C32.9978 32.477 32.9078 32.4116 32.9334 32.333C32.9448 32.2978 32.9323 32.2593 32.9024 32.2375C32.8355 32.1889 32.8698 32.0831 32.9525 32.0831C32.9895 32.0831 33.0223 32.0593 33.0337 32.0241Z",
          "M43.4057 21.4538C43.6837 21.0837 44.2718 21.3284 44.2053 21.7864L44.1861 21.9183C44.1568 22.1204 44.2682 22.3167 44.4568 22.3952L44.7311 22.5093C45.1065 22.6655 45.0953 23.2012 44.7136 23.3414L44.1879 23.5345C44.034 23.5911 43.9234 23.7275 43.8998 23.8898L43.8348 24.3372C43.7708 24.7779 43.1721 24.8641 42.9864 24.4594L42.9689 24.4213C42.8716 24.2093 42.6276 24.1078 42.4086 24.1882L42.3693 24.2027C41.9513 24.3562 41.5904 23.8709 41.8578 23.5148L42.1293 23.1533C42.2278 23.0222 42.2466 22.8476 42.1782 22.6985L41.9446 22.1896C41.7749 21.82 42.1469 21.4343 42.5224 21.5905L42.7967 21.7046C42.9853 21.7831 43.203 21.7237 43.3257 21.5604L43.4057 21.4538Z",
        ],
      },
      {
        type: "Morph",
        morphId: "morphConfigStar_202d",
        paths: [
          "M33.0337 32.0241C33.0592 31.9455 33.1705 31.9455 33.196 32.0241C33.2075 32.0593 33.2402 32.0831 33.2772 32.0831C33.3599 32.0831 33.3943 32.1889 33.3274 32.2375C33.2975 32.2593 33.285 32.2978 33.2964 32.333C33.3219 32.4116 33.2319 32.477 33.165 32.4284C33.1351 32.4066 33.0946 32.4066 33.0647 32.4284C32.9978 32.477 32.9078 32.4116 32.9334 32.333C32.9448 32.2978 32.9323 32.2593 32.9024 32.2375C32.8355 32.1889 32.8698 32.0831 32.9525 32.0831C32.9895 32.0831 33.0223 32.0593 33.0337 32.0241Z",
          "M52.2608 22.3889C52.5477 22.0646 53.0819 22.2968 53.0404 22.7278L53.0322 22.8131C53.0137 23.0058 53.1213 23.1885 53.2989 23.2657L53.3775 23.2999C53.7745 23.4725 53.7187 24.0523 53.2961 24.146L53.2124 24.1646C53.0234 24.2065 52.8829 24.3654 52.8643 24.5581L52.8561 24.6434C52.8147 25.0743 52.246 25.2004 52.0262 24.8274L51.9827 24.7536C51.8844 24.5868 51.6899 24.5022 51.5009 24.5442L51.4173 24.5627C50.9946 24.6564 50.6989 24.1546 50.9858 23.8303L51.0425 23.7661C51.1708 23.6211 51.1911 23.41 51.0928 23.2432L51.0493 23.1693C50.8296 22.7963 51.2155 22.36 51.6126 22.5326L51.6912 22.5668C51.8687 22.644 52.0758 22.5981 52.2041 22.4531L52.2608 22.3889Z",
        ],
      },
      {
        type: "Morph",
        morphId: "morphConfigStar_203d",
        paths: [
          "M33.2166 32.1491C33.2549 32.0311 33.4218 32.0311 33.4601 32.1491C33.4772 32.2018 33.5264 32.2375 33.5818 32.2375C33.7059 32.2375 33.7574 32.3962 33.6571 32.4691C33.6122 32.5017 33.5934 32.5595 33.6106 32.6123C33.6489 32.7302 33.5139 32.8283 33.4136 32.7554C33.3687 32.7228 33.3079 32.7228 33.2631 32.7554C33.1627 32.8283 33.0277 32.7302 33.0661 32.6123C33.0832 32.5595 33.0644 32.5017 33.0196 32.4691C32.9192 32.3962 32.9708 32.2375 33.0948 32.2375C33.1503 32.2375 33.1994 32.2018 33.2166 32.1491Z",
          "M51.549 27.4414C51.8483 27.1286 52.373 27.3816 52.3147 27.8106L52.172 28.8607C52.146 29.0525 52.2464 29.2394 52.4208 29.3234L53.3754 29.7836C53.7654 29.9716 53.687 30.5488 53.261 30.626L52.2182 30.8148C52.0277 30.8493 51.881 31.0025 51.8549 31.1943L51.7123 32.2445C51.654 32.6735 51.0808 32.7772 50.8758 32.3959L50.374 31.4625C50.2823 31.2919 50.0913 31.1998 49.9007 31.2343L48.8579 31.4231C48.4319 31.5002 48.1561 30.9872 48.4554 30.6744L49.1881 29.9087C49.322 29.7688 49.3505 29.5586 49.2588 29.3881L48.757 28.4547C48.552 28.0734 48.9547 27.6525 49.3447 27.8405L50.2994 28.3007C50.4738 28.3848 50.6825 28.347 50.8163 28.2071L51.549 27.4414Z",
        ],
      },
      {
        type: "Morph",
        morphId: "morphConfigStar_204d",
        paths: [
          "M33.2166 32.1491C33.2549 32.0311 33.4218 32.0311 33.4601 32.1491C33.4772 32.2018 33.5264 32.2375 33.5818 32.2375C33.7059 32.2375 33.7574 32.3962 33.6571 32.4691C33.6122 32.5017 33.5934 32.5595 33.6106 32.6123C33.6489 32.7302 33.5139 32.8283 33.4136 32.7554C33.3687 32.7228 33.3079 32.7228 33.2631 32.7554C33.1627 32.8283 33.0277 32.7302 33.0661 32.6123C33.0832 32.5595 33.0644 32.5017 33.0196 32.4691C32.9192 32.3962 32.9708 32.2375 33.0948 32.2375C33.1503 32.2375 33.1994 32.2018 33.2166 32.1491Z",
          "M49.5654 15.1471C49.9398 14.9798 50.3231 15.363 50.1557 15.7375L49.6117 16.9548C49.5361 17.1239 49.5727 17.3221 49.7037 17.4531L50.669 18.4184C50.9874 18.7368 50.6883 19.273 50.2502 19.1694L49.1375 18.9063C48.9287 18.8569 48.7142 18.963 48.6267 19.1589L48.17 20.1807C47.9956 20.5709 47.4255 20.5172 47.3271 20.1012L46.9842 18.6508C46.9453 18.4861 46.8167 18.3576 46.6521 18.3187L45.2017 17.9758C44.7857 17.8774 44.7319 17.3072 45.1222 17.1328L46.144 16.6762C46.3399 16.5886 46.4459 16.3742 46.3966 16.1653L46.1335 15.0527C46.0299 14.6145 46.566 14.3155 46.8844 14.6339L47.8497 15.5992C47.9807 15.7301 48.1789 15.7667 48.3481 15.6912L49.5654 15.1471Z",
        ],
      },
    ],
    [],
  );
  morphProps.bindInterpolation = useGenerateMorphInterpolation(myInterpolations, startValue, endValue);
  // const morphValues: {
  //   [id: string]: string[] | number[];
  // } = {};

  // function clamp(lower: number, upper: number, v: number) {
  //   let r = v;

  //   if (r > upper) {
  //     r = upper;
  //   } else if (r < lower) {
  //     r = lower;
  //   }

  //   return r;
  // }

  // type tInterpolationRange = {
  //   inputRange: number[];
  //   outputRange: string[] | number[];
  // };

  // function getInterpolationRange(morphId: string, start: number, end: number): tInterpolationRange {
  //   const initial = clamp(0, 2, start);
  //   const final = clamp(0, 2, end);
  //   const inputRange = [start, end];
  //   const outputRange: string[] | number[] = [morphValues[morphId][initial], morphValues[morphId][final]] as
  //     | string[]
  //     | number[];

  //   if (start > end) {
  //     inputRange.reverse();
  //     outputRange.reverse();
  //   }

  //   return {
  //     inputRange,
  //     outputRange,
  //   };
  // }

  React.useEffect(() => {
    const forwardMorph = [
      Animated.timing(morphAnimVal, {
        easing: Easing.ease,
        toValue: nextValue,
        duration: 500,
        delay: props.hasDelay ? 2000 : 0,
        useNativeDriver: false,
      }),
      Animated.timing(morphAnimVal, {
        easing: Easing.out(Easing.elastic(1)),
        toValue: nextValue,
        duration: 500,
        delay: props.hasDelay ? 0 : 0,
        useNativeDriver: false,
      }),
    ];

    const restartAnimation = () => {
      const nextInt = Math.ceil(nextValue);

      if (nextInt in forwardMorph) {
        forwardMorph[nextInt]?.start(() => {
          currValueRef.current = nextInt;
          onAnimationComplete();
        });
      }
    };

    if (morphAnimVal && morphAnimVal.stopAnimation) {
      morphAnimVal.stopAnimation(restartAnimation);
    } else {
      restartAnimation();
    } // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [nextValue]);
  /** End Morph Wrapper */

  /** Component Render (Javascript-React Markup) */

  if (Platform.OS === "web") {
    return (
      <View style={style}>
        <Svg
          fill="none"
          id="svg_root"
          ref={svgRef}
          style={svgStyle}
          preserveAspectRatio="xMinYMin meet"
          viewBox="0 0 88 61"
        >
          <G id="Property_201_3DClosed">
            <Svg preserveAspectRatio="xMinYMin meet" viewBox="0 0 88 61">
              <Path
                id="Rectangle_20391"
                fill="#F1F1F1"
                stroke="black"
                d="M7.19545 32.4447 H38.031729999999996 a1.11726,1.11726 0 0 1 1.11726,1.11726 V56.800839999999994 a1.11726,1.11726 0 0 1 -1.11726,1.11726 H7.19545 a1.11726,1.11726 0 0 1 -1.11726,-1.11726 V33.56196 a1.11726,1.11726 0 0 1 1.11726,-1.11726z"
                ref={morphProps.bindInterpolation}
                strokeWidth="2.23451"
                vectorEffect="non-scaling-stroke"
              />
            </Svg>
            <Svg preserveAspectRatio="xMinYMin meet" viewBox="0 0 88 61">
              <Path
                id="Vector_202"
                d="M22.3906 25.0673C27.044 21.0489 32.1407 14.3006 35.0213 19.1736C38.7112 25.4156 28.3736 25.0673 22.3906 25.0673Z"
                fill="#F1F1F1"
                stroke="black"
                strokeLinejoin="round"
                ref={morphProps.bindInterpolation}
                strokeWidth="2.23451"
                vectorEffect="non-scaling-stroke"
              />
            </Svg>
            <Svg preserveAspectRatio="xMinYMin meet" viewBox="0 0 88 61">
              <Path
                id="Vector_203"
                d="M22.8359 25.0673C18.1825 21.0489 13.0859 14.3006 10.2052 19.1736C6.51534 25.4156 16.853 25.0673 22.8359 25.0673Z"
                fill="#F1F1F1"
                stroke="black"
                strokeLinejoin="round"
                ref={morphProps.bindInterpolation}
                strokeWidth="2.23451"
                vectorEffect="non-scaling-stroke"
              />
            </Svg>
            <Svg preserveAspectRatio="xMinYMin meet" viewBox="0 0 88 61">
              <Path
                id="Subtract"
                d="M18.5899 46.2934V32.4447H26.1873V46.3448L23.7681 43.8809C22.9734 43.0715 21.6659 43.078 20.8803 43.8992L18.5899 46.2934ZM26.5702 46.7348L26.5699 46.7345L26.5702 46.7348Z"
                stroke="black"
                strokeLinejoin="round"
                ref={morphProps.bindInterpolation}
                strokeWidth="2.23451"
                vectorEffect="non-scaling-stroke"
              />
            </Svg>
            <Svg preserveAspectRatio="xMinYMin meet" viewBox="0 0 88 61">
              <Path
                id="Top"
                d="M3.3946 26.8584C3.3946 26.2414 3.89481 25.7412 4.51186 25.7412H40.2641C40.8811 25.7412 41.3813 26.2414 41.3813 26.8584V31.3274C41.3813 31.9445 40.8811 32.4447 40.2641 32.4447H4.51186C3.89481 32.4447 3.3946 31.9445 3.3946 31.3274V26.8584Z"
                fill="#F1F1F1"
                stroke="black"
                ref={morphProps.bindInterpolation}
                strokeWidth="2.23451"
                vectorEffect="non-scaling-stroke"
              />
            </Svg>
            <Svg preserveAspectRatio="xMinYMin meet" viewBox="0 0 88 61">
              <Path
                id="Star_201"
                d="M33.0337 32.0241C33.0592 31.9455 33.1705 31.9455 33.196 32.0241C33.2075 32.0593 33.2402 32.0831 33.2772 32.0831C33.3599 32.0831 33.3943 32.1889 33.3274 32.2375C33.2975 32.2593 33.285 32.2978 33.2964 32.333C33.3219 32.4116 33.2319 32.477 33.165 32.4284C33.1351 32.4066 33.0946 32.4066 33.0647 32.4284C32.9978 32.477 32.9078 32.4116 32.9334 32.333C32.9448 32.2978 32.9323 32.2593 32.9024 32.2375C32.8355 32.1889 32.8698 32.0831 32.9525 32.0831C32.9895 32.0831 33.0223 32.0593 33.0337 32.0241Z"
                fill="black"
                ref={morphProps.bindInterpolation}
                strokeWidth="1"
                vectorEffect="non-scaling-stroke"
              />
            </Svg>
            <Svg preserveAspectRatio="xMinYMin meet" viewBox="0 0 88 61">
              <Path
                id="Star_202"
                d="M33.0337 32.0241C33.0592 31.9455 33.1705 31.9455 33.196 32.0241C33.2075 32.0593 33.2402 32.0831 33.2772 32.0831C33.3599 32.0831 33.3943 32.1889 33.3274 32.2375C33.2975 32.2593 33.285 32.2978 33.2964 32.333C33.3219 32.4116 33.2319 32.477 33.165 32.4284C33.1351 32.4066 33.0946 32.4066 33.0647 32.4284C32.9978 32.477 32.9078 32.4116 32.9334 32.333C32.9448 32.2978 32.9323 32.2593 32.9024 32.2375C32.8355 32.1889 32.8698 32.0831 32.9525 32.0831C32.9895 32.0831 33.0223 32.0593 33.0337 32.0241Z"
                fill="black"
                ref={morphProps.bindInterpolation}
                strokeWidth="1"
                vectorEffect="non-scaling-stroke"
              />
            </Svg>
            <Svg preserveAspectRatio="xMinYMin meet" viewBox="0 0 88 61">
              <Path
                id="Star_203"
                d="M33.2166 32.1491C33.2549 32.0311 33.4218 32.0311 33.4601 32.1491C33.4772 32.2018 33.5264 32.2375 33.5818 32.2375C33.7059 32.2375 33.7574 32.3962 33.6571 32.4691C33.6122 32.5017 33.5934 32.5595 33.6106 32.6123C33.6489 32.7302 33.5139 32.8283 33.4136 32.7554C33.3687 32.7228 33.3079 32.7228 33.2631 32.7554C33.1627 32.8283 33.0277 32.7302 33.0661 32.6123C33.0832 32.5595 33.0644 32.5017 33.0196 32.4691C32.9192 32.3962 32.9708 32.2375 33.0948 32.2375C33.1503 32.2375 33.1994 32.2018 33.2166 32.1491Z"
                fill="black"
                ref={morphProps.bindInterpolation}
                strokeWidth="1"
                vectorEffect="non-scaling-stroke"
              />
            </Svg>
            <Svg preserveAspectRatio="xMinYMin meet" viewBox="0 0 88 61">
              <Path
                id="Star_204"
                d="M33.2166 32.1491C33.2549 32.0311 33.4218 32.0311 33.4601 32.1491C33.4772 32.2018 33.5264 32.2375 33.5818 32.2375C33.7059 32.2375 33.7574 32.3962 33.6571 32.4691C33.6122 32.5017 33.5934 32.5595 33.6106 32.6123C33.6489 32.7302 33.5139 32.8283 33.4136 32.7554C33.3687 32.7228 33.3079 32.7228 33.2631 32.7554C33.1627 32.8283 33.0277 32.7302 33.0661 32.6123C33.0832 32.5595 33.0644 32.5017 33.0196 32.4691C32.9192 32.3962 32.9708 32.2375 33.0948 32.2375C33.1503 32.2375 33.1994 32.2018 33.2166 32.1491Z"
                fill="black"
                ref={morphProps.bindInterpolation}
                strokeWidth="1"
                vectorEffect="non-scaling-stroke"
              />
            </Svg>
          </G>
        </Svg>
      </View>
    );
  }

  return (
    <View style={style}>
      <Svg
        id="native_constraint_wrapper"
        preserveAspectRatio="xMinYMin meet"
        viewBox="0 0 88 61"
        style={[svgStyle, kLocalStyles.kOverlay]}
      >
        <Path
          id="Rectangle_20391"
          fill="#F1F1F1"
          stroke="black"
          d="M7.19545 32.4447 H38.031729999999996 a1.11726,1.11726 0 0 1 1.11726,1.11726 V56.800839999999994 a1.11726,1.11726 0 0 1 -1.11726,1.11726 H7.19545 a1.11726,1.11726 0 0 1 -1.11726,-1.11726 V33.56196 a1.11726,1.11726 0 0 1 1.11726,-1.11726z"
          ref={morphProps.bindInterpolation}
          strokeWidth="2.23451"
          vectorEffect="non-scaling-stroke"
        />
      </Svg>
      <Svg
        id="native_constraint_wrapper"
        preserveAspectRatio="xMinYMin meet"
        viewBox="0 0 88 61"
        style={[svgStyle, kLocalStyles.kOverlay]}
      >
        <Path
          id="Vector_202"
          d="M22.3906 25.0673C27.044 21.0489 32.1407 14.3006 35.0213 19.1736C38.7112 25.4156 28.3736 25.0673 22.3906 25.0673Z"
          fill="#F1F1F1"
          stroke="black"
          strokeLinejoin="round"
          ref={morphProps.bindInterpolation}
          strokeWidth="2.23451"
          vectorEffect="non-scaling-stroke"
        />
      </Svg>
      <Svg
        id="native_constraint_wrapper"
        preserveAspectRatio="xMinYMin meet"
        viewBox="0 0 88 61"
        style={[svgStyle, kLocalStyles.kOverlay]}
      >
        <Path
          id="Vector_203"
          d="M22.8359 25.0673C18.1825 21.0489 13.0859 14.3006 10.2052 19.1736C6.51534 25.4156 16.853 25.0673 22.8359 25.0673Z"
          fill="#F1F1F1"
          stroke="black"
          strokeLinejoin="round"
          ref={morphProps.bindInterpolation}
          strokeWidth="2.23451"
          vectorEffect="non-scaling-stroke"
        />
      </Svg>
      <Svg
        id="native_constraint_wrapper"
        preserveAspectRatio="xMinYMin meet"
        viewBox="0 0 88 61"
        style={[svgStyle, kLocalStyles.kOverlay]}
      >
        <Path
          id="Subtract"
          d="M18.5899 46.2934V32.4447H26.1873V46.3448L23.7681 43.8809C22.9734 43.0715 21.6659 43.078 20.8803 43.8992L18.5899 46.2934ZM26.5702 46.7348L26.5699 46.7345L26.5702 46.7348Z"
          stroke="black"
          strokeLinejoin="round"
          ref={morphProps.bindInterpolation}
          strokeWidth="2.23451"
          vectorEffect="non-scaling-stroke"
        />
      </Svg>
      <Svg
        id="native_constraint_wrapper"
        preserveAspectRatio="xMinYMin meet"
        viewBox="0 0 88 61"
        style={[svgStyle, kLocalStyles.kOverlay]}
      >
        <Path
          id="Top"
          d="M3.3946 26.8584C3.3946 26.2414 3.89481 25.7412 4.51186 25.7412H40.2641C40.8811 25.7412 41.3813 26.2414 41.3813 26.8584V31.3274C41.3813 31.9445 40.8811 32.4447 40.2641 32.4447H4.51186C3.89481 32.4447 3.3946 31.9445 3.3946 31.3274V26.8584Z"
          fill="#F1F1F1"
          stroke="black"
          ref={morphProps.bindInterpolation}
          strokeWidth="2.23451"
          vectorEffect="non-scaling-stroke"
        />
      </Svg>
      <Svg
        id="native_constraint_wrapper"
        preserveAspectRatio="xMinYMin meet"
        viewBox="0 0 88 61"
        style={[svgStyle, kLocalStyles.kOverlay]}
      >
        <Path
          id="Star_201"
          d="M33.0337 32.0241C33.0592 31.9455 33.1705 31.9455 33.196 32.0241C33.2075 32.0593 33.2402 32.0831 33.2772 32.0831C33.3599 32.0831 33.3943 32.1889 33.3274 32.2375C33.2975 32.2593 33.285 32.2978 33.2964 32.333C33.3219 32.4116 33.2319 32.477 33.165 32.4284C33.1351 32.4066 33.0946 32.4066 33.0647 32.4284C32.9978 32.477 32.9078 32.4116 32.9334 32.333C32.9448 32.2978 32.9323 32.2593 32.9024 32.2375C32.8355 32.1889 32.8698 32.0831 32.9525 32.0831C32.9895 32.0831 33.0223 32.0593 33.0337 32.0241Z"
          fill="black"
          ref={morphProps.bindInterpolation}
          strokeWidth="1"
          vectorEffect="non-scaling-stroke"
        />
      </Svg>
      <Svg
        id="native_constraint_wrapper"
        preserveAspectRatio="xMinYMin meet"
        viewBox="0 0 88 61"
        style={[svgStyle, kLocalStyles.kOverlay]}
      >
        <Path
          id="Star_202"
          d="M33.0337 32.0241C33.0592 31.9455 33.1705 31.9455 33.196 32.0241C33.2075 32.0593 33.2402 32.0831 33.2772 32.0831C33.3599 32.0831 33.3943 32.1889 33.3274 32.2375C33.2975 32.2593 33.285 32.2978 33.2964 32.333C33.3219 32.4116 33.2319 32.477 33.165 32.4284C33.1351 32.4066 33.0946 32.4066 33.0647 32.4284C32.9978 32.477 32.9078 32.4116 32.9334 32.333C32.9448 32.2978 32.9323 32.2593 32.9024 32.2375C32.8355 32.1889 32.8698 32.0831 32.9525 32.0831C32.9895 32.0831 33.0223 32.0593 33.0337 32.0241Z"
          fill="black"
          ref={morphProps.bindInterpolation}
          strokeWidth="1"
          vectorEffect="non-scaling-stroke"
        />
      </Svg>
      <Svg
        id="native_constraint_wrapper"
        preserveAspectRatio="xMinYMin meet"
        viewBox="0 0 88 61"
        style={[svgStyle, kLocalStyles.kOverlay]}
      >
        <Path
          id="Star_203"
          d="M33.2166 32.1491C33.2549 32.0311 33.4218 32.0311 33.4601 32.1491C33.4772 32.2018 33.5264 32.2375 33.5818 32.2375C33.7059 32.2375 33.7574 32.3962 33.6571 32.4691C33.6122 32.5017 33.5934 32.5595 33.6106 32.6123C33.6489 32.7302 33.5139 32.8283 33.4136 32.7554C33.3687 32.7228 33.3079 32.7228 33.2631 32.7554C33.1627 32.8283 33.0277 32.7302 33.0661 32.6123C33.0832 32.5595 33.0644 32.5017 33.0196 32.4691C32.9192 32.3962 32.9708 32.2375 33.0948 32.2375C33.1503 32.2375 33.1994 32.2018 33.2166 32.1491Z"
          fill="black"
          ref={morphProps.bindInterpolation}
          strokeWidth="1"
          vectorEffect="non-scaling-stroke"
        />
      </Svg>
      <Svg
        id="native_constraint_wrapper"
        preserveAspectRatio="xMinYMin meet"
        viewBox="0 0 88 61"
        style={[svgStyle, kLocalStyles.kOverlay]}
      >
        <Path
          id="Star_204"
          d="M33.2166 32.1491C33.2549 32.0311 33.4218 32.0311 33.4601 32.1491C33.4772 32.2018 33.5264 32.2375 33.5818 32.2375C33.7059 32.2375 33.7574 32.3962 33.6571 32.4691C33.6122 32.5017 33.5934 32.5595 33.6106 32.6123C33.6489 32.7302 33.5139 32.8283 33.4136 32.7554C33.3687 32.7228 33.3079 32.7228 33.2631 32.7554C33.1627 32.8283 33.0277 32.7302 33.0661 32.6123C33.0832 32.5595 33.0644 32.5017 33.0196 32.4691C32.9192 32.3962 32.9708 32.2375 33.0948 32.2375C33.1503 32.2375 33.1994 32.2018 33.2166 32.1491Z"
          fill="black"
          ref={morphProps.bindInterpolation}
          strokeWidth="1"
          vectorEffect="non-scaling-stroke"
        />
      </Svg>
    </View>
  );
};
/***/

export default React.memo(MagicBox);
